import { render, staticRenderFns } from "./trainBoxright.vue?vue&type=template&id=3b95b202&scoped=true&"
import script from "./trainBoxright.vue?vue&type=script&lang=js&"
export * from "./trainBoxright.vue?vue&type=script&lang=js&"
import style0 from "./trainBoxright.vue?vue&type=style&index=0&id=3b95b202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95b202",
  null
  
)

export default component.exports